import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import Collapse from "@material-ui/core/Collapse";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import FavoriteIcon from "@material-ui/icons/Favorite";
import ShareIcon from "@material-ui/icons/Share";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import FolderIcon from "@material-ui/icons/Folder";
import PageviewIcon from "@material-ui/icons/Pageview";
import AssignmentIcon from "@material-ui/icons/Assignment";
import { Link } from "@reach/router";
import Icon from "@material-ui/core/Icon";
import SvgIcon from "@material-ui/core/SvgIcon";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import ModelButton from "./ModelButton";
import Zmage from "react-zmage";
import CardMediaStepper from "./CardMediaStepper";
import SERVER_ADDRESS from "../../../../config";
import { QRCodeButton } from "../../panopage";
import {
  EditTiaowenDialogButton,
  EditGoujianImageDialogButton,
  EditGoujianDialogButton
} from "../../utils";

const useStyles = makeStyles(theme => ({
  media: {
    width: "100%"
  },

  cardheader: {
    backgroundColor: theme.palette.secondary.main
  },
  actions: {
    color: theme.palette.secondary.light,
    display: "flex"
  },
  grow: {
    flexGrow: 1
  }
}));

//获取构件位置信息图
function useGoujianPosition(initValue, goujianId) {
  const [goujianPosition, setGoujianPosition] = useState(initValue);
  const fetchUrl = `${SERVER_ADDRESS}/api/goujianimages/?description=位置关系图&category=图纸&goujian__id=${goujianId}`;

  useEffect(() => {
    async function getGoujianPosition() {
      const goujianPosition = await fetch(fetchUrl, {
        mode: "cors",
        credentials: "include"
      }).then(res => {
        return res.json();
      });
      //使用第0张图,确保最早上传的位置构件图作为展示用
      setGoujianPosition(goujianPosition[0]);
    }
    getGoujianPosition();
  }, [goujianId]);
  return goujianPosition;
}

//主要的Card组件,显示构件详情
function GoujianCard(props) {
  const classes = useStyles();
  const { goujian, postionMedia, qrCode, freshData } = props;
  const goujianPosition = useGoujianPosition({}, goujian.id);
  const [mediaType, toggleMediaType] = useState(postionMedia ? true : false);
  const {
    name,
    sketch,
    category,
    description,
    id,
    sketch_thumbnail
  } = props.goujian;

  return (
    <div>
      <Card raised>
        <CardHeader
          className={classes.cardheader}
          avatar={
            <Avatar
              aria-label="类型"
              className={classes.avatar}
              src={sketch_thumbnail}
            />
          }
          action={
            qrCode ? null : (
              <IconButton
                title="详细信息"
                onClick={() => {
                  window.open(`/info/goujian/${id}`);
                }}
              >
                <SvgIcon>
                  <path d="M12,2C6.477,2,2,6.477,2,12s4.477,10,10,10s10-4.477,10-10S17.523,2,12,2z M13,17h-2v-6h2V17z M13,9h-2V7h2V9z" />
                </SvgIcon>
              </IconButton>
            )
          }
          title={name}
          subheader={category}
        />
        <CardMedia
          className={classes.media}
          image={
            mediaType && Object.keys(goujianPosition).length !== 0
              ? goujianPosition.thumbnail
              : sketch_thumbnail
          }
          title={`${name}(点击查看大图)`}
          component="img"
          onClick={() => {
            window.open(
              mediaType && Object.keys(goujianPosition).length !== 0
                ? goujianPosition.image
                : sketch
            );
          }}
        />
        <CardContent>
          {Object.keys(goujianPosition).length !== 0 ? (
            <CardMediaStepper
              toggleImage={() => {
                toggleMediaType(!mediaType);
              }}
            />
          ) : null}

          <Typography>{description}</Typography>
        </CardContent>

        <CardActions className={classes.actions}>
          {goujian.obj_model ? (
            <ModelButton obj_model={goujian.obj_model} />
          ) : null}

          <div className={classes.grow} />
          {qrCode ? null : (
            <>
              <EditTiaowenDialogButton
                goujian={goujian}
                button
                buttonText="新建条文"
              />

              <EditGoujianImageDialogButton
                goujian={goujian}
                button
                buttonText="新建图片"
              />
            </>
          )}

          <EditGoujianDialogButton
            initFormValue={goujian}
            freshData={data => {
              freshData(data, "update");
            }}
          />
          {/* 
          <Link to={`/info/goujian/goujiantiaowens/${id}`}>
            <IconButton title="文献">
              <SvgIcon>
                <path d="M14,2H6C4.9,2,4,2.9,4,4v16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V8L14,2z M16,18H8v-2h8V18z M16,14H8v-2h8V14z M13,9V3.5 L18.5,9H13z" />
              </SvgIcon>
            </IconButton>
          </Link>
          <Link to={`/info/goujian/goujianimages/${id}`}>
            <IconButton title="图片">
              <SvgIcon>
                <path d="M20,4H4C2.895,4,2,4.895,2,6v12c0,1.105,0.895,2,2,2h16c1.105,0,2-0.895,2-2V6C22,4.895,21.105,4,20,4z M5,17l3.5-4.5 l2.5,3.01L14.5,11l4.5,6H5z" />
              </SvgIcon>
            </IconButton>
          </Link> */}

          {/* <EditIconToggleButton goujian={props.goujian} /> */}
        </CardActions>
      </Card>
    </div>
  );
}
export default GoujianCard;
